export interface PurchaserIdentity {
  purchaserType?: string;
  companyName?: string | null;
  firstName?: string;
  middleName?: string | null;
  lastName?: string;
}
export const purchaserName = (c?: PurchaserIdentity | null): string => {
  if (!c) return 'Client unavailable';
  return (c.purchaserType === 'CORPORATE' ? c.companyName : [c.firstName, c.middleName, c.lastName].filter(Boolean).join(' ')) || 'Unnamed client';
};
export const purchaserInitials = (c: PurchaserIdentity) => purchaserName(c).split(/\s+/).slice(0, 2).map(p => p[0]).join('').toUpperCase();
